import { render, staticRenderFns } from "./DrawerReferences.vue?vue&type=template&id=7aa19108&scoped=true"
import script from "./DrawerReferences.vue?vue&type=script&lang=js"
export * from "./DrawerReferences.vue?vue&type=script&lang=js"
import style0 from "./DrawerReferences.vue?vue&type=style&index=0&id=7aa19108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa19108",
  null
  
)

export default component.exports